module.exports = __webpack_public_path__ + "static/media/3-4.74252d16.mp3";